import React, {Component} from 'react';
import {NavLink} from "react-router-dom";
import {BASE_PATH} from "../../../../../wpconfig";

class DScholar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isInit: false,
			show: false
		}
	}

	onShowHideClick = () => {
		this.setState({
			show: !this.state.show
		})
	}

	render() {
		const record = this.props.record;

		if (!record.scholar)
			return '';

		let buttonClass = "icon icon-size-24 icon-plus-black align-top mr-2"
		if(this.state.show)
			buttonClass = "icon icon-size-24 icon-minus-black align-top mr-2"
		return (
			<div>
				<div className="mt-65">
					<div className="d-flex justify-content-between align-items-center mb-px-26">
						<div className="d-flex align-items-center">
							<h3 className="con-title">연구자</h3>
						</div>
					</div>
					<div>
						<div className="researcher-info-list">
							<div className="d-flex flex-wrap mt-px-n5 mr-px-n5 mb-px-n5 ml-px-n5">
								{record.scholar && record.scholar.map((item, num) => {
									if (num > 9 && !this.state.show)
										return ''
									return (
										<div key={num} className="w-20 pt-px-5 pr-px-5 pb-px-5 pl-px-5">
											<NavLink to={BASE_PATH + "scholar/?record_id=" + item.scholar_id}>
												<div className="researcher-info-item">
													<div className="researcher-name">{item.scholar_name}</div>
													<div className="researcher-cate">{item.sinbun_name}</div>
												</div>
											</NavLink>
										</div>
									)
								})}
							</div>
						</div>
					</div>
					{record.scholar.length > 5 &&
					<div className="mt-4">
						<div className="text-center">
							<button className="btn btn-outline-gray btn-lg" onClick={this.onShowHideClick}>
								<span className={buttonClass}/>
								<strong>연구자 {this.state.show ? '닫기' : '전체보기'}</strong></button>
						</div>
					</div>
					}
				</div>
			</div>
		);
	}
};

export default DScholar;
